import { window } from '../../../../globals';
import useToastedMutation from '../../../../ReactQuery/useToastedMutation';
import { post } from '../../../../redux/api';
import { hardRedirectTo } from '../../../../utils';
import type { ConnectStartResponse, InstallUrlRequest } from '../../../../../shared/types/routes/vcs/githubApp';
import type { VcsApp } from '../../../../../shared/vcs/githubApp/apps';

const startGitHubAppConnect = async (app: VcsApp) => {
  // Send the current path so the connect callback returns the user here (the import page).
  const returnPath = `${window.location.pathname}${window.location.search}`;
  const response = await post<InstallUrlRequest, ConnectStartResponse>(
    `/api/vcs/github-apps/${app}/connect/start`,
    { returnPath },
  );
  if (!response.data) {
    throw new Error('Empty response from connect start');
  }
  return response.data;
};

/**
 * The "Install on GitHub" entry point. Sends the user to GitHub to authorize, so CORE can see
 * which installations their account already has. They come back to the import page either with
 * `?connect=ready` (accounts to choose from, shown in the connect modal) or straight on GitHub's
 * install page when there was nothing to connect.
 */
export function useStartGitHubAppConnect() {
  return useToastedMutation({
    mutationFn: startGitHubAppConnect,
    onSuccess: ({ authUrl }) => {
      hardRedirectTo(authUrl);
    },
    errorToastMessage: 'Failed to start GitHub authorization',
  });
}
